import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const MenuContainer = styled.div`
	display: flex;
	flex-direction: row-reverse;
	justify-content: flex-end;
	padding: var(--padding-2) var(--padding-2) var(--padding-1) var(--padding-2);
	flex-wrap: wrap;
	width: 100%;
	align-items: center;
	gap: 1rem;

	> button {
		@media ${Breakpoints.mobile} {
			> .button-text {
				display: none;
			}
		}
	}

	.search-input.expandable {
		input {
			width: 12rem;

			:hover,
			:active,
			:focus {
				width: 25rem;
			}
		}

		:focus-within > input {
			width: 25rem;
		}
	}

	@media ${Breakpoints.mobile} {
		padding: var(--padding-4) var(--padding-2);
		flex-wrap: unset;
		justify-content: flex-end;

		.search-input {
			input {
				width: 20rem;
			}
		}
	}
`;

export const LeftMenuWrapper = styled.div`
	display: flex;
	justify-content: flex-end;

	@media ${Breakpoints.mobile} {
		width: 100%;
		gap: 1rem;

		.search-input {
			input {
				width: 20rem;
			}
		}
	}
`;

export const RightMenuWrapper = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
`;

export const MenuWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	flex-wrap: wrap;

	@media ${Breakpoints.mobile} {
		> div {
			width: 100% !important;
			margin: 0 !important;
		}
	}
`;

export const MobileMenuContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
	border-top: 1px solid var(--border-color);
	padding: var(--padding-2);

	> .button {
		border-color: var(--black-10);
	}
`;

export const Menu = styled.div`
	display: flex;
	flex-direction: column;
	box-shadow: var(--container-box-shadow);
	padding: var(--padding-2);
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	min-width: 20rem;
	z-index: var(--z-index-2);
	margin: 0 0 auto var(--margin-2);
	overflow: auto;
	max-height: 80dvh;

	> .search-input {
		margin-bottom: var(--margin-1);
	}

	body[dir='rtl'] & {
		margin: 0 var(--margin-2) auto 0;
	}

	&.leftSide {
		margin: 0 var(--margin-2) auto 0;

		body[dir='rtl'] & {
			margin: 0 0 auto var(--margin-2);
		}
	}

	&.filterOptions {
		min-width: 30rem;
		max-width: 48rem;

		@media ${Breakpoints.mobile} {
			max-width: 100%;
			min-width: unset;
		}
	}

	@media ${Breakpoints.mobile} {
		overflow: unset;
		max-height: unset;
	}
`;

export const MenuItem = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	min-height: 4rem;
	padding: var(--padding-2) var(--padding-3);
	z-index: var(--z-index-1);
	cursor: pointer;
	border-inline-start: 2px solid transparent;

	:hover {
		background-color: var(--table-selected-color);
	}

	> .typography {
		flex: 1;
		color: var(--black);
		margin-left: var(--margin-2);

		body[dir='rtl'] & {
			margin-left: unset;
			margin-right: var(--margin-2);
		}
	}

	&.selected {
		background-color: var(--table-active-color);
		border-inline-start: 2px solid var(--blue);
		border-radius: 0;

		> .typography {
			color: var(--blue);
		}
	}
`;

export const FilterMenuItem = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	min-height: 4rem;
	padding: var(--padding-2) var(--padding-3);
	z-index: var(--z-index-1);
	cursor: pointer;
	border-inline-start: 2px solid transparent;

	> .typography {
		flex: 1;
		color: var(--black);
		margin-left: var(--margin-2);

		body[dir='rtl'] & {
			margin-left: unset;
			margin-right: var(--margin-2);
		}
	}

	input {
		cursor: pointer;
	}

	&.selected {
		background-color: var(--table-active-color);
		border-inline-start: 2px solid var(--blue);
		border-radius: 0;
	}
`;

export const ButtonContainer = styled.span`
	display: flex;
	justify-content: center;
	flex-direction: row;
	margin: var(--margin-2) 0;
	gap: 1rem;
`;

export const FilterColumnsButtonContainer = styled.span`
	display: flex;
	justify-content: flex-end;
	flex-direction: row;
	margin: var(--margin-2) 0;
`;

export const ColumnsMenu = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: var(--padding-2);
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	min-width: 24rem;
	z-index: var(--z-index-2);
	box-shadow: var(--container-box-shadow);
	margin: 0 0 0 var(--margin-2);
	max-height: 44rem;
	overflow: auto;

	> .search-input {
		margin-bottom: var(--margin-1);
	}

	body[dir='rtl'] & {
		margin: 0 var(--margin-2) 0 0;
	}

	> button {
		flex: 1 0 100%;
	}

	@media ${Breakpoints.mobile} {
		margin: 0 !important;
	}
`;

export const ColumnsMenuItem = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	min-height: 4rem;
	border-radius: var(--small-border-radius);
	padding: var(--padding-2) var(--padding-3);
	z-index: var(--z-index-1);
	cursor: ${(props) => (props.isFiltered ? 'not-allowed' : 'move')};
	border-inline-start: 2px solid transparent;
	position: relative;

	> .icon {
		display: none;
		position: absolute;
		right: 0;
		background: inherit;

		body[dir='rtl'] & {
			right: unset;
			left: 0;
		}
	}

	:hover {
		background-color: var(--table-selected-color);

		> .icon {
			display: block;
		}
	}

	.typography {
		flex: 1;
		cursor: ${(props) => (props.isFiltered ? 'not-allowed' : 'move')};
		font-size: var(--paragraph3-font-size);
		color: var(--black);
		font-weight: 500;
		margin-left: var(--margin-2);

		body[dir='rtl'] & {
			margin-left: unset;
			margin-right: var(--margin-2);
		}
	}

	input {
		cursor: pointer;
	}

	&.selectAll {
		cursor: pointer;

		.typography {
			cursor: pointer;
		}
	}

	&.selected {
		background-color: var(--table-active-color);
		border-inline-start: 2px solid var(--blue);
		border-radius: 0;
	}
`;

export const FilterContainer = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 1rem;
	padding: var(--spacing-3);

	> .tag {
		cursor: pointer;
	}

	@media ${Breakpoints.mobile} {
		display: none;
	}
`;

export const FilterValue = styled.span`
	max-width: 20rem;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

export const RemoveFilterContainer = styled.div`
	display: inline-flex;
	justify-content: center;
	align-items: center;
`;

export const MobileRemoveFilterContainer = styled.div`
	display: inline-flex;
	justify-content: center;
	align-items: center;

	position: fixed;
	bottom: 6rem;
	background: var(--black);
	z-index: 1;
	padding: 0 1rem;
	left: 50%;
	transform: translate(-50%, 0);
	border-radius: 4px;
`;

export const RemoveFilterButtonCss = css`
	text-decoration: underline;

	@media ${Breakpoints.mobile} {
		text-decoration-color: var(--blue-50) !important;

		> .button-text {
			color: var(--blue-50) !important;
		}
	}
`;

export const MobileFilterDot = styled.span`
	display: none;
	position: absolute;
	width: 0.75rem;
	height: 0.75rem;
	border-radius: 50%;
	background-color: var(--red-70);
	right: 0.75rem;
	top: 0.75rem;

	@media ${Breakpoints.mobile} {
		display: block;
	}
`;

export const MobileColumnDot = styled.span`
	display: none;
	position: sticky;
	width: 0.75rem;
	height: 0.75rem;
	border-radius: 50%;
	background-color: var(--red-70);

	@media ${Breakpoints.mobile} {
		display: block;
	}
`;

export const Line = styled.span`
	width: 1px;
	background-color: var(--background-3);
`;
